/* src/app/timeline-workshop/pages/timeline-workshop/timeline-workshop.component.scss */
.timelineLineContainer {
  display: flex;
  flex-flow: row wrap;
}
.fullcontainer {
  padding-left: 15rem;
}
/*# sourceMappingURL=timeline-workshop.component.css.map */
